// @flow

import { noop } from 'lodash';
import { addTags } from './utils/addTags';
import {
  getViewportWidth,
  getViewportHeight
} from 'src/modules/responsive-helpers';

const addSizeTags = solMetadata =>
  addTags(solMetadata, {
    'seek:innerWidth': `${getViewportWidth()}`,
    'seek:innerHeight': `${getViewportHeight()}`
  });

const getSolWrapper = () => {
  if (ENV.SERVER) {
    return {
      trackSearchEvent: noop,
      monitorSearchImpression: noop,
      monitorSearchImpressionOff: noop,
      trackActivity: noop
    };
  }

  return {
    trackSearchEvent: (solMetaData: *, onComplete: *) => {
      window.sol('SEARCH', addSizeTags(solMetaData), onComplete);
    },
    monitorSearchImpression: (node: *, solMetaData: *, onComplete: *) => {
      window.sol(
        'MONITOR:IMPRESSION',
        node,
        addSizeTags(solMetaData),
        onComplete
      );
    },
    monitorSearchImpressionOff: (node: *, solMetaData: *, onComplete: *) => {
      window.sol(
        'MONITOR:IMPRESSION:OFF',
        node,
        addSizeTags(solMetaData),
        onComplete
      );
    },
    trackActivity: (trackType: *, solMetaData: *, onComplete: *) => {
      window.sol('ACTIVITY', trackType, addSizeTags(solMetaData), onComplete);
    }
  };
};

export default getSolWrapper;
